<!--
   Created by qing on 2020/11/10
   Des: 模板页面
-->
<template>
  <div class="space-template-container" v-if="pageDetail" v-wechat-title="title">
    <van-swipe :autoplay="3000" v-if="pageDetail.openSlideshow">
      <van-swipe-item
        v-for="(item, index) in pageDetail.slideshowImageList"
        :key="index">
        <img
          @click="onClickImage(item)"
          :src="item.imageUrl"
          class="swipe-img"/>
      </van-swipe-item>
    </van-swipe>
    <div class="flow-container" v-if="pageDetail.openTodo">
      <div class="flow-container-wrapper">
        <a
          v-for="item in taskList"
          :href="item.href"
          class="flow-item">
          <div class="item-badge">
            <div class="icon">
              <van-icon :name="item.icon"/>
            </div>
            <div class="count" v-if="item.badge">
              {{item.badge}}
            </div>
          </div>
          <div class="text">
            {{item.title}}
          </div>
        </a>
      </div>
    </div>

    <div class="button-container">

      <div
        class="button-item"
        v-for="item in pageDetail.customButtonList"
        :key="item.key"
        @click="onClickButton(item)">
        <div
          v-if="item.buttonType === 'CUSTOM'"
          class="icon button-icon"
          :style="{backgroundColor: item.bgColor}">
          <i :class="item.buttonIcon" :style="{color: item.bgColor === '#ffffff' ? '#333333' : '#ffffff'}"></i>
        </div>
        <img
          v-if="item.buttonType === 'IMAGE'"
          class="icon button-img"
          :src="item.imageUrl" />
        <div class="text">
          {{item.buttonName}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    HOME_TAB_TYPE_FORM_DETAIL,
    HOME_TAB_TYPE_APP,
    HOME_TAB_TYPE_DASHBOARD,
    HOME_TAB_TYPE_FORM_APPLY,
    HOME_TAB_TYPE_TODO_TASK,
    HOME_TAB_TYPE_APP_FORMS,
    HOME_TAB_TYPE_MINE,
    HOME_TAB_TYPE_TEMPLATE,
    HOME_TAB_TYPE_VIEW,
    HOME_TAB_TYPE_HTML, HOME_TAB_TYPE_MIX_FORM
  } from "../../../assets/types";

  export default {
    inject: ['reload'],
    data() {
      return {
        aEle: null,
        pageDetail: null,
        taskList: [
          {
            title: '我的待办',
            badge: '',
            icon: 'comment-o',
            href: `${this.$MINIAPP_BASE_PATH}/#/flow/todo`
          },
          {
            title: '我发起的',
            badge: '',
            icon: 'play-circle-o',
            href: `${this.$MINIAPP_BASE_PATH}/#/flowList/create`
          },
          {
            title: '我处理的',
            badge: '',
            icon: 'certificate',
            href: `${this.$MINIAPP_BASE_PATH}/#/flowList/dispose`
          },
          {
            title: '抄送我的',
            badge: '',
            icon: 'description',
            href: `${this.$MINIAPP_BASE_PATH}/#/flowList/cc`
          }
        ],
        pageConfigId: '',
        title: ''
      }
    },
    async created() {
      this.aEle = document.createElement('a')

      this.pageConfigId = this.$route.params.pageConfigId
      const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
        spaceId: this.$route.params.spaceId,
        pageConfigId: this.$route.params.pageConfigId
      }).catch(console.error)

      this.title = pageConfig.pageTitle
      this.$store.dispatch('setPageTitle', this.title)
      this.pageDetail = pageConfig.pageConfigDetail || {}
      this.fetchNum()
    },
    methods: {

      fetchNum() {
        this.$store.dispatch('actionFormHandleNumber', {
          appId: '',
          companyId: this.$store.getters.currentCompanyId
        }).then(res => {
          if (res.waitHandleCount) {
            this.taskList[0].badge = res.waitHandleCount > 99 ? '99+' : String(res.waitHandleCount)
          }
          if (res.ccNum) {
            this.taskList[3].badge = res.ccNum > 99 ? '99+' : String(res.ccNum)
          }
        }).catch(console.error)
      },
      onClickButton(item) {
        console.log('onClickButton',item)
        if (!item.pageConfigId || !item.pageType) {
          this.$toast.fail('配置信息有误,请联系管理员')
          return
        }
        let route = null
        switch (item.pageType) {
          case HOME_TAB_TYPE_FORM_DETAIL:
            route = {
              path: `/single/formDetail/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_APP:
            this.$store.dispatch('actionSpacePageConfigDetail', {
              spaceId: this.$route.params.spaceId,
              pageConfigId: item.pageConfigId
            }).then(res => {
              if (res.pageConfigDetail && res.pageConfigDetail.appId) {
                this.$router.push({
                  name: 'appHome',
                  query: {
                    appId: res.pageConfigDetail.appId
                  }
                })
              } else {
                this.$toast.fail('配置信息有误,请联系管理员')
              }
            }).catch(console.error)
            break
          case HOME_TAB_TYPE_DASHBOARD:
            route = {
              path: `/single/dashboard/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_FORM_APPLY:
            route = {
              path: `/single/fillForm/${item.pageConfigId}?sceneId=${this.$route.query.sceneId}`
            }
            break
          case HOME_TAB_TYPE_TODO_TASK:
            route = {
              path: `/single/todoTask/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_APP_FORMS:
            route = {
              path: `/single/forms/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_MINE:
            route = {
              path: `/single/mine/${item.pageConfigId}`,
              query: {
                canCut: 0
              }
            }
            break
          case HOME_TAB_TYPE_TEMPLATE:
            route = {
              path: `/single/customTemp/${item.pageConfigId}?sceneId=${this.$route.query.sceneId}`
            }
            break
          case HOME_TAB_TYPE_VIEW:
            route = {
              path: `/single/dataView/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_HTML:
            route = {
              path: `/single/customHtml/${item.pageConfigId}`
            }
            break
          case HOME_TAB_TYPE_MIX_FORM:
            route = {
              path: `/single/customMixForm/${item.pageConfigId}`
            }
            break
        }

        if (route) {
          this.$router.push(route)
        }
      },
      onClickImage(item) {
        if (this.aEle && item.jumpUrl) {
          this.aEle.href = item.jumpUrl
          this.aEle.target = '_blank'
          this.aEle.click()
        }
      }
    },
    watch: {
      $route(to, from) {
        if (this.$route.params.pageConfigId) {
          console.info( "加载页面数据" );
          if (this.pageConfigId !== this.$route.params.pageConfigId) {
            this.reload()
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .space-template-container {
    height: 100%;
    position: relative;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #ffffff;

    .swipe-img {
      width: 100%;
      height: 180px;
      object-fit: cover;
    }

    .flow-container {
      background-color: #ffffff;
      height: 120px;
      padding: 20px 12px;

      .flow-container-wrapper {
        display: flex;
        justify-content: space-around;
        height: 80px;
        background: #fff;
        border: 1px solid #e9e9e9;
        border-radius: 8px;
        box-shadow: 0 0.15rem 0.75rem -1px rgba(0, 0, 0, 0.08);

        .flow-item {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-between;
          padding: 12px 0;
          color: #248AF9;
          text-decoration: none;
          outline: none;

          .item-badge {
            position: relative;
            display: inline-block;

            .icon {
              position: relative;
              width: 28px;
              height: 28px;

              i {
                font-size: 26px;
              }
            }

            .count {
              position: absolute;
              right: -5px;
              top: 5px;
              height: 20px;
              min-width: 20px;
              text-align: center;
              padding: 0 4px;
              color: white;
              font-size: 13px;
              line-height: 20px;
              background: #E64340;
              border-radius: 50%;
              -webkit-transform: translate(50%, -50%);
              transform: translate(50%, -50%);
            }
          }

          .text {
            color: #1F2D3D;
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }
    }

    .button-container {
      width: 100%;
      background-color: #fff;
      display: flex;
      flex-wrap: wrap;
      padding: 10px;

      .button-item {
        width: 25%;
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .icon {
          width: 60px;
          height: 60px;
          border-radius: 10px;
          /*border: 1px solid #e6e6e6;*/

          i {
            font-size: 30px;
            color: #ffffff;
          }
        }

        .button-icon {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .button-img {
          object-fit: cover;
        }

        .text {
          margin-top: 10px;
          font-size: 14px;
          color: #333333;
          width: 100%;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }
      }
    }
  }
</style>